import HistoriesPage from "../../pages/dashboard/histories/HistoriesPage";
import HistoryDetailPage from "../../pages/dashboard/histories/HistoryDetailPage";

export const HistoriesRoutes = [
  {
    name: "Lịch sử",
    path: "",
    element: <HistoriesPage />,
  },
  {
    name: "Chi tiết lịch sử",
    path: ":id",
    element: <HistoryDetailPage />,
  },
];
